import { create } from "zustand";

const activeSessionStore = (set) => ({
  activeSession: undefined,
  setactiveSession: (v) => set({ activeSession: v }),
});

const questionStateStore = (set) => ({
  questionStatus: undefined,
  setquestionStatus: (v) => set({ questionStatus: v }),
});

/*---------------------------------

  create Store

---------------------------------*/
export const useLiveStore = create((set) => ({
  ...activeSessionStore(set),
  ...questionStateStore(set),
}));
